module.exports = __webpack_public_path__ + "img/state2.16d52f45.png";